/**
 * saturn-grid-pricing.js — collection-grid price fix (consumer of saturn-pricing.js)
 *
 * Dawn's product card renders the native variant price via {% render 'price' %},
 * which is door-blind: on the Bulk collection a greeted card shows its $7 single
 * price, not the real bulk entry cost. This script reads the per-card pricing_config
 * island emitted by card-product.liquid (.saturn-card-config), resolves the active
 * door from the collection slug, computes the price at that door's minimum via the
 * shared engine, and swaps the misleading native price for a door-correct one
 * ("$187.50 — 50-card minimum · $3.75/card").
 *
 * Scope:
 *  - On a collection page whose slug maps to a door (below), rewrites tiles at
 *    that door's minimum.
 *  - Everywhere else (Shop All, native /collections/all, search, home/featured
 *    rows) SINGLE-DOOR products self-present their own door (2026-07-15): a
 *    Personalize tile's config is [D] only, and its bare "$5.75" native price is
 *    misleading without the 50-card context — so it rewrites itself no matter
 *    where it tiles. Multi-door products (Greeted = A+C) keep the native price
 *    off door pages, since Individual is their honest default.
 *  - Rewrites ONLY volume-tier doors with a real minimum (Bulk C, Personalize D).
 *    Block/Individual (Door A) keeps the theme's native per-card price unchanged.
 *
 * Requires saturn-pricing.js (window.SaturnPricing) loaded FIRST.
 * Keep COLLECTION_DOOR_MAP in sync with DAWN_ADAPTER.collectionDoorMap in
 * saturn-pricing-pdp.js.
 */
(function () {
  "use strict";

  var COLLECTION_DOOR_MAP = {
    'holiday': 'A',
    'bulk': 'C',
    'holiday-bulk': 'C',
    'personalization': 'D',
    'personalized': 'D',
    'holiday-personalization': 'D',
    'holiday-boxes': 'B'
  };

  function warn(msg) { if (window.console) console.warn('[saturn-grid] ' + msg); }

  // Collection pages are /collections/<slug> (no trailing product), so unlike the
  // PDP resolver we match without requiring a following segment.
  function resolveDoor() {
    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!m) return null;
    return COLLECTION_DOOR_MAP[m[1]] || null;
  }

  function injectStyles() {
    if (document.getElementById('saturn-grid-styles')) return;
    var s = document.createElement('style');
    s.id = 'saturn-grid-styles';
    s.textContent = [
      '.saturn-grid-price{font-size:15px;line-height:1.35;margin-top:.2rem}',
      '.saturn-grid-price__total{font-weight:600}',
      '.saturn-grid-price__note{display:block;font-size:13px;opacity:.7;margin-top:.1rem}'
    ].join('');
    document.head.appendChild(s);
  }

  function rewriteCard(SP, node, door) {
    if (node.dataset.saturnGridDone) return;  // idempotent: never double-process
    var config;
    try { config = JSON.parse(node.textContent); }
    catch (e) { warn('bad card config: ' + e); return; }
    if (!config || !config.doors) return;

    var cfg;
    if (door) {
      cfg = config.doors[door];
      if (!cfg) return;  // this product doesn't serve the collection's door
    } else {
      // No door context: self-resolve. Only single-door products present their
      // door off door pages (Personalize = [D]); multi-door keep native price.
      var keys = Object.keys(config.doors);
      if (keys.length !== 1) return;
      cfg = config.doors[keys[0]];
    }

    // Only fix where the native variant price is misleading: a volume-tier door
    // with a real minimum. Block/Individual keeps its native per-card price.
    if (cfg.model !== 'volume_tiers' || !cfg.minQty || cfg.minQty <= 1) return;

    var r = SP.computePricing(cfg, cfg.minQty);
    if (!r.valid) return;

    var container = node.closest('.card-information') || node.parentNode;
    var nativePrice = container ? container.querySelector('.price') : null;

    var el = document.createElement('div');
    el.className = 'saturn-grid-price';
    el.innerHTML =
      '<span class="saturn-grid-price__total">' + SP.formatCents(r.subtotalCents) + '</span>' +
      '<span class="saturn-grid-price__note">' + cfg.minQty + '-card minimum · ' +
      SP.formatCents(r.unitEffectiveCents) + '/card</span>';

    if (nativePrice) {
      nativePrice.style.display = 'none';
      nativePrice.insertAdjacentElement('afterend', el);
    } else {
      node.insertAdjacentElement('afterend', el);
    }
    node.dataset.saturnGridDone = '1';
  }

  function init() {
    var SP = window.SaturnPricing;
    if (!SP || !SP.computePricing) { warn('saturn-pricing.js not loaded before this script'); return; }

    // door is null off door pages — rewriteCard then self-resolves per card
    // (single-door products only), covering Shop All / search / featured rows.
    var door = resolveDoor();

    var nodes = document.querySelectorAll('.saturn-card-config');
    if (!nodes.length) return;

    injectStyles();
    nodes.forEach(function (node) { rewriteCard(SP, node, door); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // v1 limitation: Dawn re-renders the grid via the Section Rendering API on facet
  // filtering / pagination, producing fresh cards this DOMContentLoaded pass won't
  // catch — their prices revert to native until reload. Re-run init() on Dawn's
  // collection-render event in a later pass if filtered grids need the fix too.
})();